"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapBooleanFieldProperties = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var _FieldMapper = _interopRequireWildcard3(require("./FieldMapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LoadableCheckbox = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../Checkbox"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachBooleanComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});
var LoadableToggle = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../Toggle"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachBooleanComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});

var onChange = function onChange(params) {
  var event = params[0];
  var checked = event.target.checked;
  var isChecked = checked !== null && checked !== void 0 ? checked : false;
  return {
    value: isChecked
  };
};

var mapCheckboxProperties = function mapCheckboxProperties(field, model) {
  var isChecked = typeof model.value === "boolean" ? model.value : false;
  return _objectSpread(_objectSpread({}, model), {}, {
    name: model.id,
    component: LoadableCheckbox,
    onChange: onChange,
    value: isChecked
  });
};

var mapToggleProperties = function mapToggleProperties(field, model) {
  var isChecked = typeof model.value === "boolean" ? model.value : false;
  return _objectSpread(_objectSpread({}, model), {}, {
    name: model.id,
    component: LoadableToggle,
    onChange: onChange,
    value: isChecked
  });
};

var mapBooleanFieldProperties = function mapBooleanFieldProperties(_ref) {
  var field = _ref.field,
      htmlId = _ref.htmlId,
      value = _ref.value,
      onValidation = _ref.onValidation;
  var model = (0, _FieldMapper.default)(field, htmlId, value, undefined, onValidation);

  switch (field.properties.editor) {
    case "Checkbox":
      return mapCheckboxProperties(field, model);

    case "Toggle":
      return mapToggleProperties(field, model);

    default:
      return null;
  }
};

exports.mapBooleanFieldProperties = mapBooleanFieldProperties;